const USER_STATUS = {
  WORKING: 1, // dang lam viec
  MATERNITY_LEAVE: 2, // nghi thai san
  QUIT_JOB: 3, // da nghi viec
};

const MARITAL_STATUS = {
  SINGLE: 0, // độc thân
  MARRIED: 1, // đã kết hôn
};

const PANEL_TYPES = {
  INFORMATION: 'information',
  INFORMATIONENG: 'information_eng',
  STAFF_INFO: 'staff_info',
  LEVEL_HISTORY: 'level_history',
  SALARY_HISTORY: 'salary_history',
  POSITION_HISTORY: 'position_history',
  CAPACITY: 'capacity',
};

export { USER_STATUS, MARITAL_STATUS, PANEL_TYPES };
